"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentStatusTimes_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Appointment_1 = require("./Appointment");
var LocationSeatingLocation_1 = require("./LocationSeatingLocation");
var AppointmentStatusTimes_Factory = /** @class */ (function () {
    function AppointmentStatusTimes_Factory() {
    }
    AppointmentStatusTimes_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Appointment: Appointment_1.Appointment_Factory.CreateIncoming(model.Appointment),
            CheckedIn: Date_Factory_1.Date_Factory.CreateIncoming(model.CheckedIn),
            CheckedOut: Date_Factory_1.Date_Factory.CreateIncoming(model.CheckedOut),
            ReadyToBeSeen: Date_Factory_1.Date_Factory.CreateIncoming(model.ReadyToBeSeen),
            RecordId: model.RecordId,
            Seated: Date_Factory_1.Date_Factory.CreateIncoming(model.Seated),
            SeatingLocation: LocationSeatingLocation_1.LocationSeatingLocation_Factory.CreateIncoming(model.SeatingLocation),
            SeatingLocationId: model.SeatingLocationId,
        };
        return result;
    };
    AppointmentStatusTimes_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Appointment: Appointment_1.Appointment_Factory.CreateOutgoing(model.Appointment),
            CheckedIn: Date_Factory_1.Date_Factory.CreateOutgoing(model.CheckedIn),
            CheckedOut: Date_Factory_1.Date_Factory.CreateOutgoing(model.CheckedOut),
            ReadyToBeSeen: Date_Factory_1.Date_Factory.CreateOutgoing(model.ReadyToBeSeen),
            RecordId: model.RecordId,
            Seated: Date_Factory_1.Date_Factory.CreateOutgoing(model.Seated),
            SeatingLocation: LocationSeatingLocation_1.LocationSeatingLocation_Factory.CreateOutgoing(model.SeatingLocation),
            SeatingLocationId: model.SeatingLocationId,
        };
        return result;
    };
    return AppointmentStatusTimes_Factory;
}());
exports.AppointmentStatusTimes_Factory = AppointmentStatusTimes_Factory;
